/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import "./node_modules/uikit/dist/css/uikit.min.css";
import "./src/css/site.scss";

UIkit.use(Icons);

export const onRouteUpdate = () => {
  if (document.body.className.indexOf("uk-offcanvas-container") > -1) {
    UIkit.offcanvas(document.getElementById("mobileNav")).hide();
  }
};
